/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

export const LOAD_ADDRESS_BOOK_ENTRY = 'MFE/ADDRESSBOOK/LOAD_ADDRESS_BOOK_ENTRY';
export const LOAD_BILLING_ADDRESS_BOOK_ENTRY = 'MFE/ADDRESSBOOK/LOAD_BILLING_ADDRESS_BOOK_ENTRY';
export const PROCESS_ADDRESS_BOOK_ENTRY_COMPLETED = 'MFE/ADDRESSBOOK/PROCESS_ADDRESS_BOOK_ENTRY_COMPLETED';
export const SET_ADDRESS_BOOK_ENTRY_LIST = 'MFE/ADDRESSBOOK/SET_ADDRESS_BOOK_ENTRY_LIST';
export const CLEAR_ADDRESS_BOOK_ENTRY = 'MFE/ADDRESSBOOK/CLEAR_ADDRESS_BOOK_ENTRY';
export const SAVED_ADDRESS_BOOK_ENTRY = 'MFE/ADDRESSBOOK/SAVED_ADDRESS_BOOK_ENTRY';
export const ADD_ADDRESS_BOOK_ENTRY = 'MFE/ADDRESSBOOK/ADD_ADDRESS_BOOK_ENTRY';
export const EDIT_ADDRESS_BOOK_ENTRY = 'MFE/ADDRESSBOOK/EDIT_ADDRESS_BOOK_ENTRY';
export const REMOVE_ADDRESS_BOOK_ENTRY = 'MFE/ADDRESSBOOK/REMOVE_ADDRESS_BOOK_ENTRY';
export const SET_BILLING_USER_ADDRESS_BOOK_ENTRY = 'MFE/ADDRESSBOOK/SET_BILLING_USER_ADDRESS_BOOK_ENTRY';
